// The scenario clock: while playing, advance time by wall time × speed each animation frame, or along
// the timeline's pacing (a clip's slow motion) when Paced is on.
// Periodic timelines (a cardiac cycle) wrap; others stop at the end. The timeline is the main
// sim's time base once one loads, or in a view on its own pack, its run's (app/scene.ts).

import { useAtlas } from './store.ts';
import { defaultSpeed, timelineOf, viewTimelineOf } from './scene.ts';
import { advancePaced } from '../data/sims/time.ts';

let raf = 0;
let last = 0;

function tick(now: number) {
  raf = requestAnimationFrame(tick);
  const s = useAtlas.getState();
  const tl = timelineOf(s);
  const dt = last ? Math.min(0.1, (now - last) / 1000) : 0;
  last = now;
  if (!s.playing || !tl) return;
  let t = s.paced && tl.pacing ? advancePaced(tl.pacing, s.time, dt) : s.time + dt * s.speed;
  if (tl.start && t < tl.start) t = tl.start;
  if (t >= tl.duration) {
    if (tl.periodic) t %= tl.duration;
    else {
      t = tl.duration;
      s.setPlaying(false);
    }
  }
  s.setTime(t);
}

/** A view's own run (H01's activity) brings its timeline when the pack's load replies: offer its speeds,
 *  and keep the time inside it. (The scene's sims do the same for theirs as they load, app/sims.ts.) */
export function fitViewClock(): () => void {
  return useAtlas.subscribe(viewTimelineOf, (tl) => {
    if (!tl) return;
    const s = useAtlas.getState();
    if (!tl.speeds.includes(s.speed)) s.setSpeed(defaultSpeed(tl));
    if (s.time > tl.duration) s.setTime(tl.start ?? 0);
  });
}

export function startClock() {
  if (raf) return;
  raf = requestAnimationFrame(tick);
  fitViewClock();
}
